/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import IconButton from "../../shared/v2/IconButton/IconButton";
import { XmarkRegularV6 } from "../../shared/v2/Icomoon";
import useMobileMenu from "./hooks/useMobileMenu";
import MenuOption from "./MenuOption";
import Menu from "./Menu";
import BackButton from "./BackButton";
import QuickSearch from "../../QuickSearch/components/QuickSearch";
import { setSelectedMenuOption } from "../../reducers/layoutReducer";

const MobileSidebar = ({ preventMenuOpen, onAction }) => {
  const {
    actions,
    data: { isMobileMenuOpen, isSubmenuOpen },
  } = useMobileMenu();
  const dispatch = useDispatch();
  const theme = useSelector(({ layout }) => layout.theme);
  const sidebar = useSelector(({ layout }) => layout.sidebar);
  const selectedMenuOption = useSelector(({ layout }) => layout.selectedMenuOption);

  return createPortal(
    <>
      {isMobileMenuOpen && (
        <div
          className="tw-z-3000 tw-absolute tw-inset-0 tw-flex tw-justify-start tw-bg-black/15"
          onClick={actions.toggleMobileMenu}
        />
      )}
      <nav
        className={`tw-absolute tw-top-0 tw-left-0 tw-bottom-0 tw-z-3000 tw-max-w-[404px] tw-w-full tw-pr-[24px] tw-flex tw-transition-transform tw-ease-in-out tw-duration-300 ${
          isMobileMenuOpen ? "tw-translate-x-0" : "-tw-translate-x-full"
        }`}
        onClick={actions.toggleMobileMenu}
        data-cy="side-navbar"
        id="sidebar"
      >
        <div
          className={`tw-flex tw-flex-col tw-gap-[12px] tw-p-[12px] tw-flex-1 tw-w-full tw-rounded-r-[16px] tw-overflow-y-auto tw-shadow-nav ${
            theme.name === "place-theme" ? "tw-bg-[#121212]" : "tw-bg-[#f9fbfb]"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="tw-flex tw-justify-end">
            <IconButton schema="transparent" onClick={actions.toggleMobileMenu}>
              <XmarkRegularV6 size="xl" />
            </IconButton>
          </div>
          <QuickSearch />
          <div className="tw-relative tw-w-full tw-h-full tw-overflow-hidden">
            <div
              className={`tw-absolute tw-transition-left tw-duration-300 tw-top-0 tw-bottom-0 ${
                !preventMenuOpen && selectedMenuOption?.name ? "tw-left-[calc(-100%-12px)]" : "tw-left-0"
              } tw-w-full tw-overflow-y-auto`}
            >
              {sidebar.menu.map((m) => (
                <MenuOption
                  key={m.name}
                  className="tw-font-bold"
                  isMobile
                  submenu={selectedMenuOption?.name}
                  option={m}
                  onClick={() => dispatch(setSelectedMenuOption(m))}
                />
              ))}
            </div>
            <div
              className={`tw-flex tw-flex-col tw-absolute tw-transition-left tw-duration-300 tw-top-0 tw-bottom-0 ${
                !preventMenuOpen && selectedMenuOption?.name ? "tw-left-0" : "tw-left-[calc(100%+12px)]"
              } tw-w-full tw-overflow-hidden`}
            >
              {!isSubmenuOpen && (
                <div>
                  <BackButton onClick={() => dispatch(setSelectedMenuOption(null))}>Back</BackButton>
                </div>
              )}
              <Menu
                title={selectedMenuOption?.name}
                options={selectedMenuOption?.options?.filter(
                  (o) => typeof o.enabled === "undefined" || o.enabled,
                )}
                onAction={onAction}
              />
            </div>
          </div>
        </div>
      </nav>
    </>,
    document.body,
  );
};

export default MobileSidebar;
